// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__X7916","large":"styles_large__czg48"};